import { normalizeLegalNotice } from '@sse/shared';
const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
const kinds = [['privacy', 'Privacy policy'], ['terms', 'Terms & conditions'], ['additional', 'Another link']];
export function legalNoticeEditorHTML(value = {}, supported = true) {
  const links = Array.isArray(value.links) ? value.links : [];
  return `<div id="mag-legal-notice"><p class="mag-modal__hint">Add a short notice and links to your policies.</p>
    <div class="mag-tog-row"><input id="mag-legal-enabled" type="checkbox" ${value.enabled ? 'checked' : ''} ${!supported && !value.enabled ? 'disabled' : ''}><label for="mag-legal-enabled">Show notice and policy links</label></div>
    ${!supported ? '<p class="mag-modal__hint">Update this magnet’s website experience to show notices and policy links.</p>' : ''}
    <div data-legal-fields ${value.enabled ? '' : 'hidden'}>
    <label class="mag-modal__label" for="mag-legal-text">Notice text <span class="mag-modal__hint">(optional)</span></label>
    <textarea id="mag-legal-text" class="mag-modal__input" rows="3" maxlength="600" aria-describedby="mag-legal-count">${esc(value.text || '')}</textarea>
    <p id="mag-legal-count" class="mag-modal__hint">${(value.text || '').length}/600 characters</p>
    ${kinds.map(([kind, label]) => {
      const link = links.find(l => l.kind === kind) || {};
      const fields = `<div class="mag-legal-link"><label class="mag-modal__label" for="mag-legal-${kind}-url">${label} URL${kind === 'additional' ? '' : ' (optional)'}</label>
        <input id="mag-legal-${kind}-url" class="mag-modal__input" type="url" maxlength="2048" placeholder="https://example.com/${kind === 'privacy' ? 'privacy' : 'terms'}" value="${esc(link.url || '')}">
        <label class="mag-modal__label" for="mag-legal-${kind}-label">Link text</label>
        <input id="mag-legal-${kind}-label" class="mag-modal__input" maxlength="60" value="${esc(link.label || (kind === 'additional' ? '' : label))}"></div>`;
      return kind === 'additional' ? `<details ${link.url ? 'open' : ''}><summary>Add another link</summary>${fields}</details>` : fields;
    }).join('')}
    </div><p class="mag-modal__hint" data-legal-empty hidden>Add text or a link to show a notice.</p></div>`;
}
export function collectLegalNotice(root) {
  const value = id => root.querySelector(`#mag-legal-${id}`)?.value || '';
  return {enabled: !!root.querySelector('#mag-legal-enabled')?.checked, text: value('text'), links: kinds.flatMap(([kind]) => {
    const url = value(`${kind}-url`).trim(), label = value(`${kind}-label`).trim();
    return url || (kind === 'additional' && label) ? [{kind, url, label}] : [];
  })};
}
export function legalNoticeProblem(root) {
  try { normalizeLegalNotice(collectLegalNotice(root)); return ''; } catch (e) { return e.message; }
}
export function refreshLegalNoticeEditor(root) {
  const fieldset = root.querySelector('[data-legal-fields]');
  if (!fieldset) return;
  const value = collectLegalNotice(root);
  fieldset.hidden = !value.enabled;
  root.querySelector('#mag-legal-count').textContent = `${value.text.length}/600 characters`;
  root.querySelector('[data-legal-empty]').hidden = !value.enabled || !!value.text.trim() || value.links.length > 0;
}
